import { SignalDot, StageBar } from '@indipia/ui-core'
import type { ScheduleListCells } from '../../types/scheduleList.types'
import { cellStatusText, DIM_TEXT_STYLE, LIST_ORDER_ERROR_TEXT, SIGNAL_TEXT_COLOR, stageTone } from './listStyle'
import { LANE_NO_SIGNAL_TEXT, LANE_UNKNOWN_TEXT } from '../../constants/scheduleListStage.logic'
import { STAGE_STEP_NAMES } from '../../types/scheduleList.types'

// 3칸 셀(D-05 ③) — 신호 점 + 상태 글자 + 단계 막대. 해당 없음·신호 없음·판정 불가·발주 부분 오류는 점·막대 없이 글자만.
// 막대 위치(d·c)와 색은 B-01~03 이 정한 값을 그대로 그린다. 판정을 다시 하지 않는다.

export interface ScheduleListStageCellProps {
  cell: ScheduleListCells['foreman'] | ScheduleListCells['order'] | ScheduleListCells['work']
}

export function ScheduleListStageCell({ cell }: ScheduleListStageCellProps) {
  if (cell.status === 'none') {
    const text = cellStatusText(cell)
    // 시공 해당 없음(자재시공)은 간트 신호등과 같은 빗금 점 + 짧은 글자. 발주 해당 없음은 글자만
    if (cell.slot !== 'FOREMAN') return <span style={DIM_TEXT_STYLE}>{text}</span>
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--spacing-02)' }} title={text}>
        <SignalDot color="NONE" size={8} />
        <span style={DIM_TEXT_STYLE}>{text}</span>
      </span>
    )
  }
  if (cell.status === 'no-signal') return <span style={DIM_TEXT_STYLE}>{LANE_NO_SIGNAL_TEXT}</span>
  if (cell.status === 'unknown') return <span style={DIM_TEXT_STYLE} title={cell.reasonCode}>{LANE_UNKNOWN_TEXT}</span>
  if (cell.status === 'order-error') return <span style={{ fontSize: 'var(--type-caption-size)', color: 'var(--status-danger-600)' }}>{LIST_ORDER_ERROR_TEXT}</span>

  const s = cell.stage
  const text = cellStatusText(cell)
  const doneName = s.d > 0 ? STAGE_STEP_NAMES[s.kind][Math.min(s.d, s.stepCount) - 1] : null
  const barLabel = `${s.stepCount}단계 중 ${s.d}단계 끝남${doneName ? ` (${doneName})` : ''}`
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-02)' }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--spacing-02)' }} title={text}>
        <SignalDot color={s.color} size={8} />
        <span style={{ fontSize: 'var(--type-caption-size)', fontWeight: 700, color: SIGNAL_TEXT_COLOR[s.color], whiteSpace: 'nowrap' }}>{text}</span>
      </span>
      <StageBar total={s.stepCount} done={s.d} current={s.c != null} tone={stageTone(s.color)} label={barLabel} />
    </div>
  )
}
